import { trackAnalyticsEvent } from '@jsmdg/tracking';
import { type GA4ClickEvent } from '@jsmdg/tracking/dist/events';
import { type SlidingDirections } from '@jsmdg/yoshi';

type TrackSlideProps = {
    direction: SlidingDirections;
    category: string;
    eventData?: GA4ClickEvent;
};

export function trackSlide({ direction, category, eventData }: TrackSlideProps): void {
    trackAnalyticsEvent({
        category,
        action: 'Slide',
        label: direction,
        eventData,
    });
}
